var _excluded = ["html", "customElementHandler", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import c from 'classnames';
import Button from '../Button';
var WysiwygField = function WysiwygField(_ref) {
  var html = _ref.html,
    _ref$customElementHan = _ref.customElementHandler,
    customElementHandler = _ref$customElementHan === void 0 ? function () {} : _ref$customElementHan,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = c('WysiwygField', className);
  var parsedHtml = ReactHtmlParser(html, {
    transform: function transform(node) {
      var customHandler = customElementHandler(node);
      if (customHandler) {
        return customHandler;
      }
      switch (node.name) {
        case 'a':
          {
            if (node.attribs.class && node.attribs.class.indexOf('button--primary') !== -1) {
              var label = node.children[0].data;
              return /*#__PURE__*/React.createElement(Button, {
                primary: true,
                withIcon: true,
                buttonIcon: true,
                href: node.attribs.href,
                target: node.attribs.target || '',
                rel: node.attribs.target ? 'noopener' : '',
                key: "".concat(node.name, ":").concat(label)
              }, label);
            }
            break;
          }
        default:
          {
            break;
          }
      }
    }
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), parsedHtml);
};
WysiwygField.propTypes = {
  html: PropTypes.string.isRequired,
  customElementHandler: PropTypes.func,
  className: PropTypes.string
};
WysiwygField.defaultProps = {
  customElementHandler: function customElementHandler() {},
  className: ''
};
export default WysiwygField;